import Input from "./Input";


function InputDateFourNumbers(props) {

    const handleInputChange = (e) => {
        const oldE = e;
        let input = e.replace(/\D/g, '');

        (input.length > 2) && (input = `${input.slice(0, 2)}/${input.slice(2)}`);
        props.onChange(input);
    }

    return (
        <Input 
        {...props}
        onChange={handleInputChange}
        />
    )
}


export default InputDateFourNumbers;